import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

// Selectors
import { selectBuyingReportRoute, selectRouteToSearch } from '../../../../store/selectors/routes'
import { selectHomebotListingsFeatureEnabled } from '../../../../store/selectors/customerProfile'

// Actions
import { setCreateClientFrom } from '../../../../store/slices/navigation'

// Components
import { Button, ComponentTrackingType } from '@homebotapp/hb-react-component-catalog'

// Constants
import { defineMessages, useIntl } from 'react-intl'

interface BuyersLinkProps {
  className?: string
  affordability: number
  from: string
  tracking?: ComponentTrackingType
}

const MSG = defineMessages({
  startYourSearch: {
    id: 'Homeowner.purchasePower.explore',
    defaultMessage: 'Start your search'
  }
})

export const BuyersLink = ({ className, affordability, from, tracking }: BuyersLinkProps) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const intl = useIntl()

  const homebotListingEnabled = useSelector(selectHomebotListingsFeatureEnabled)
  const pathname = useSelector(selectBuyingReportRoute)

  const to = {
    pathname,
    affordability
  }
  const listingsPath = useSelector(selectRouteToSearch)

  const handleOnClick = () => {
    dispatch(setCreateClientFrom(from))
    // "affordability is being added to the location object and consumed in InitializeContainer, where it is then passed to "ConfirmCreateBuyer"
    // this is weird and bad, but I'm afraid to touch it right now - it should probably be a query string param, or set in redux state
    history.push(to)
  }

  const handleHomebotListingsClick = () => {
    history.push(listingsPath)
  }

  return (
    // Should be a link
    <Button
      className={className}
      onClick={homebotListingEnabled ? handleHomebotListingsClick : handleOnClick}
      tracking={{
        ...tracking,
        descriptor: MSG.startYourSearch.defaultMessage
      }}
    >
      {intl.formatMessage(MSG.startYourSearch)}
    </Button>
  )
}
